import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "19",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M3.75 9.31c0-.437.373-.792.833-.792h10.834c.46 0 .833.355.833.792v.38c0 .437-.373.792-.833.792H4.583c-.46 0-.833-.355-.833-.792z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M12.782 4.1c.111.105.174.248.174.397a.55.55 0 0 1-.174.397l-2.367 2.247a.6.6 0 0 1-.419.164.6.6 0 0 1-.418-.164L7.21 4.894a.55.55 0 0 1-.166-.395.55.55 0 0 1 .174-.392.6.6 0 0 1 .413-.164.6.6 0 0 1 .416.157l1.358 1.288v-4.26c0-.15.062-.292.173-.397a.6.6 0 0 1 .418-.165c.157 0 .308.06.419.165a.55.55 0 0 1 .173.397v4.26L11.945 4.1a.6.6 0 0 1 .419-.164c.157 0 .307.059.418.164M7.218 14.9a.55.55 0 0 1-.174-.397c0-.15.063-.292.174-.397l2.367-2.246a.6.6 0 0 1 .419-.165c.157 0 .307.06.418.165l2.367 2.246a.55.55 0 0 1 .167.395.55.55 0 0 1-.174.392.6.6 0 0 1-.413.164.6.6 0 0 1-.416-.157l-1.357-1.288v4.26a.55.55 0 0 1-.174.397.6.6 0 0 1-.418.165.6.6 0 0 1-.419-.165.55.55 0 0 1-.173-.397v-4.26L8.055 14.9a.6.6 0 0 1-.419.164.6.6 0 0 1-.418-.164",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }